/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Fail_FetchInputs */

const en_import_fail_fetch = /** @type {(inputs: Import_Fail_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page couldn't be loaded`)
};

const de_import_fail_fetch = /** @type {(inputs: Import_Fail_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Seite konnte nicht geladen werden`)
};

/**
* | output |
* | --- |
* | "The page couldn't be loaded" |
*
* @param {Import_Fail_FetchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_fail_fetch = /** @type {((inputs?: Import_Fail_FetchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Fail_FetchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_fail_fetch(inputs)
	return en_import_fail_fetch(inputs)
});